module.exports = __webpack_public_path__ + "img/PL08729.6083cac8.png";